import { useEffect, useState } from "react";
import { myBet } from "../api";
import { useDispatch, useSelector } from "react-redux";
import { addBet } from "../redux/slices/accountSlice";
import { getBets, getUserLoggedInType, selectSite } from "../utils/helper/commonSelectors";
import { useSearchParams } from "react-router-dom";
import { isMobile } from "react-device-detect";

export default function MatchedBet() {

  let Bets = useSelector(getBets());

  const loggedInUserType = useSelector(getUserLoggedInType());

  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const eventId = Number(searchParams.get("eventId"));
  const eventType = Number(searchParams.get("eventType"));
  const sportsName = searchParams.get("sportsName") || "";
  const marketId = searchParams.get("marketId") || "";
  const gmid = searchParams.get("gmid") || "";

  const [isFetching, setIsFetching] = useState(false);

  const eventIdNumber = eventId ? Number(eventId) : null;
  const topHeaderColor = useSelector(selectSite())?.headerColor;
  if (sportsName === "greyhound") {
    Bets = Bets?.filter((bet) => bet.marketId === gmid)
  }
  if (sportsName === "horse") {
    Bets = Bets?.filter((bet) => bet.marketId === gmid)
  }

  useEffect(() => {
    let intervalId;

    const fetchBets = async () => {
      if (isFetching || loggedInUserType !== "real") return;

      setIsFetching(true);
      try {
        const response = await myBet();
        const betData = response?.data?.data || [];
        dispatch(addBet(betData.slice().reverse()));
      } catch (error) {
        console.error("Error fetching bets:", error);
      } finally {
        setIsFetching(false);
      }
    };

    // Fetch immediately and then set interval
    if (loggedInUserType === "real") {
      fetchBets();
    }
    intervalId = setInterval(fetchBets, 10000);

    return () => clearInterval(intervalId);
  }, [dispatch]);

  useEffect(() => {
    if (eventId) {
      const filteredBets = Bets?.filter((bet) => bet.eventId == eventId);
      if (JSON.stringify(filteredBets) !== JSON.stringify(Bets)) {
        dispatch(addBet(filteredBets));
      }
    }
  }, [eventId, Bets, dispatch]);

  const [isActive, setIsActive] = useState(false);

  const toggleSwitch2 = () => {
    setIsActive(prev=> !prev);
  };
  console.log({isActive});
  
  return (
    <div className={`bg-white h-full mx-auto lg:block min-h-72 ${isMobile ? "": "mt-7"}`}>
      <style>{`
        .slider-switch {
          position: absolute;
          cursor: pointer;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: red;
          transition: 0.4s;
          border-radius: 34px;
        }

        .slider-switch:before {
          position: absolute;
          content: "";
          height: 14px;
          width: 14px;
          border-radius: 50%;
          left: 4px;
          bottom: 4px;
          background-color: white;
          transition: 0.4s;
        }

        input:checked + .slider-switch {
          background-color: #1d8821;
        }

        input:checked + .slider-switch:before {
          transform: translateX(18px);
        }

        @media only screen and (max-width: 800px) {
          .tv-main {
            display:none
          }
        }
      
      `}</style>

      <div className="tv-main ">
        {eventIdNumber > 1 && (
          <h2 className="font-bold sm:p-1.5 text-xs w-[100%] flex justify-end px-4 bg-[#18adc5] text-white">
            <div className="flex items-center gap-2">
              <span className={!isActive ? "font-bold underline" : ""} onClick={()=> setIsActive(false)} >Live Score</span>
              <label
                htmlFor="switch-desktop"
                className="relative inline-block w-10 h-5"
              >
                <input
                  id="switch-desktop"
                  type="checkbox"
                  className="opacity-0 w-0 h-0"
                  onChange={toggleSwitch2}
                  checked={isActive}
                />
                <span className="slider-switch round"></span>
              </label>
              <span className={isActive ? "font-bold underline" : ""} onClick={()=>setIsActive(true)} >Live TV</span>
            </div>
          </h2>
        )}

        {eventIdNumber > 1 && (
          <iframe
            
            src={
              isActive
                ? (window.location.hostname == "cricball99.club" || window.location.hostname == "royalexch.online" ? `https://dpmatka.in/dtv.php?id=${eventId}&sportid=${eventType}&muted` : `https://${window.location.hostname}/tv-not-found`)
                : `https://asianexchange.club/score?sport_id=${eventType}&event_id=${eventId}`
            }
            allow="autoplay; picture-in-picture"
            width="100%"
            height={247}
            loading="lazy"
            style={{ backgroundColor: "#141435" }}
          ></iframe>
        )}
      </div>

      <h2 className="text-xs p-1.5 px-4 font-bold mb-0.5 text-white" style={{
        backgroundImage: `linear-gradient(180deg, ${topHeaderColor?.start}, ${topHeaderColor?.end})`,
      }}>
        Placed Bets
      </h2>
      <div className="overflow-x-auto overflow-y-auto h-full shadow">
        <table className="w-full border-collapse">
          <thead>
            <tr className="bg-[#028DAD] text-white text-xs">
              <th className="py-1 px-4 text-left">Sports</th>
              <th className="py-1 px-4 text-left">Market</th>
              <th className="py-1 px-4 text-left">Selection</th>
              <th className="py-1 px-4 text-left">Odds</th>
              <th className="py-1 px-4 text-left">Stake</th>
            </tr>
          </thead>
          <tbody>
            {Bets?.length > 0 ? (
              Bets?.map((bet, index) => (
                <tr
                  key={index}
                  className={`border-b text-xs ${bet.type === "Back"
                    ? "bg-lightblue text-white"
                    : "bg-pink text-white"
                    }`}
                >
                  <td className="py-2 px-4 bg-transparent">
                    {bet?.sportsName ?? "N/A"}
                  </td>
                  <td className="py-2 px-4 bg-transparent">
                    {bet?.market ?? "N/A"}
                  </td>
                  <td className="py-2 px-4 bg-transparent">
                    {bet?.selection && bet?.markettype
                      ? `${bet.selection}`
                      : "N/A"}
                  </td>
                  <td className="py-2 px-4 bg-transparent">
                    {bet.oddsReq ?? bet.price ?? "N/A"}
                  </td>
                  <td className="py-2 px-4 bg-transparent">
                    {bet?.stake ?? "N/A"}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan="5"
                  className="py-4 px-4 text-center text-primary text-sm"
                >
                  No bets found...
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
